module.exports = __webpack_public_path__ + "img/logo-datasoft.369c7aff.png";